import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { FinancialYearData } from 'src/app/Models/financialyeardata';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-financialyeardata',
  templateUrl: './financialyeardata.component.html',
  styleUrls: ['./financialyeardata.component.css']
})
export class FinancialyeardataComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: FinancialYearData;
    isSpinning = false
  logtext:string = "";



  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - FinancialYearData form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
   if (this.data.SR_NO == undefined || this.data.SR_NO == 0 ){
      this.message.error("Please Enter Sr. No.", "");
      isOk = false
      
    }
    if (this.data.NAME == undefined || this.data.NAME == "0" ){
      this.message.error("Please Enter Name", "");
      isOk = false
      
    }
    if (this.data.AMOUNT1 == undefined || this.data.AMOUNT1 == 0 ){
      this.message.error("Please Enter  Amount1", "");
      isOk = false
      
    }
    if (this.data.AMOUNT2 == undefined || this.data.AMOUNT2 == 0 ){
      this.message.error("Please Enter  Amount2", "");
      isOk = false
      
    }
    if(isOk){
    

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateFinancialYearData(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("FinancialYearData information updated Successfully...", "");

	this.logtext = 'Update & Close - FinancialYearData form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - FinancialYearData ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - FinancialYearData form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - FinancialYearData ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update financialYearData information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createFinancialYearData(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("FinancialYearData information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - FinancialYearData form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialYearData ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new FinancialYearData();
	this.logtext = 'Save & New - FinancialYearData form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialYearData ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add financialYearData information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - FinancialYearData form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - FinancialYearData ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}